import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/database';

const supabaseUrl = 'https://zusdifjwquyyimpfqpwf.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp1c2RpZmp3cXV5eWltcGZxcHdmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU3MzUzMDgsImV4cCI6MjA1MTMxMTMwOH0.OWyxpod0sNYZ7rZg9e4EwHsaTQSTh90KAJRGr-DYMZg';

export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true
    }
  }
);